import { Button, Card } from '@kalos/ui';
import { Link } from '@tanstack/react-router';
import { Home } from 'lucide-react';
import { type FC } from 'react';

interface PropertyNotFoundProps {
  propertyId: number;
  reason?: 'not-found' | 'deleted';
}

export const PropertyNotFound: FC<PropertyNotFoundProps> = ({
  propertyId,
  reason = 'not-found',
}) => {
  const deleted = reason === 'deleted';
  return (
    <div className="container mx-auto flex min-h-[50vh] items-center justify-center p-4">
      <Card className="max-w-md bg-white p-8 text-center">
        <h2 className="mb-2 text-xl font-semibold text-gray-900">
          {deleted ? 'Property Deleted' : 'Property Not Found'}
        </h2>
        <p className="mb-6 text-gray-600">
          {deleted
            ? `Property #${propertyId} has been deleted and is no longer available.`
            : `Property #${propertyId} doesn't exist. Double-check the ID and try again.`}
        </p>
        <Button asChild>
          <Link to="/">
            <Home className="mr-2 h-4 w-4" />
            Back to Dashboard
          </Link>
        </Button>
      </Card>
    </div>
  );
};
